import styled from 'styled-components'
import Wrapper from 'common/wrapper'
import LearningPlanFixedElements from './learning-plan-fixed-elements'
import LearningPlanMenu from './learning-plan-menu'

const LearningPlanLayoutStyled = styled.div`
  padding-block-start: 4.5rem;
  padding-block-end: 1rem;
  background: radial-gradient(44.43% 53.01% at 50% 55.44%, #073555 27.4%, #04001E 100%);
  background-attachment: fixed;
  .menu {
    display: none;
  }
  @media(min-width: 1024px) {
    padding-block-start: 1.5rem;
    padding-block-end: 4.5rem;
    /* margin-block-start: 1.5rem; */
    .menu {
      display: block;
      padding: 0;
      ul {
        display: flex;
        flex-direction: column;
        gap: 1rem;
      }
      a {
        width: fit-content;
        display: flex;
        gap: .5rem;
        align-items: center;
        font: var(--regularBold);
        button {
          padding-block: .5rem;
        }
        &.active .link {
          box-shadow: 0px 4px 0px var(--secondary);
        }
      }
    }
    .learning-plan-grid-courses {
      display: grid;
      grid-template-columns: max-content 1fr;
      justify-items: end;
      grid-template-columns: 1fr 384px;
      justify-items: end;
      gap: 1rem;
    }
    .base-grid {
      display: grid;
      grid-template-columns: 180px 1fr;
      gap: 1rem;
    }
  }
  @media(min-width: 1200px) {
    .learning-plan-grid-courses {
      gap: 8rem;
    }
  }
`

function LearningPlanLayout({ children }) {
  return (
    <LearningPlanLayoutStyled>
      <Wrapper maxWidth="1200">
        <div className="base-grid">
          <LearningPlanMenu />
          {children}
        </div>
        <LearningPlanFixedElements />
      </Wrapper>
    </LearningPlanLayoutStyled>
  )
}

export default LearningPlanLayout
